var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4991 7.9375H16.2491C16.2491 5.45513 13.8385 4.32288 11.8741 4.06213V2.25H10.1241V4.06213C8.15977 4.32288 5.74915 5.45513 5.74915 7.9375C5.74915 10.3053 8.08189 11.5364 10.1241 11.8138V16.1625C8.85715 15.9429 7.49915 15.2665 7.49915 14.0625H5.74915C5.74915 16.3279 7.87102 17.6666 10.1241 17.944V19.75H11.8741V17.9388C13.8385 17.678 16.2491 16.5449 16.2491 14.0625C16.2491 11.5801 13.8385 10.4479 11.8741 10.1871V5.8375C13.0379 6.04662 14.4991 6.66087 14.4991 7.9375ZM7.49915 7.9375C7.49915 6.66087 8.9604 6.04662 10.1241 5.8375V10.0366C8.92452 9.81525 7.49915 9.15987 7.49915 7.9375ZM14.4991 14.0625C14.4991 15.3391 13.0379 15.9534 11.8741 16.1625V11.9625C13.0379 12.1716 14.4991 12.7859 14.4991 14.0625Z",
    fill: "url(#paint0_linear_2063_7375)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2063_7375",
    x1: 8.59915,
    y1: -1,
    x2: 18.2173,
    y2: 19.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DF47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DF4DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.4c8e5b80f9356307c1046f0bdcca7ff9.svg";
export { ForwardRef as ReactComponent };